module.exports = __webpack_public_path__ + "img/appAsset-brand--oneclickLogo.2c69da28.svg";